module.exports = __webpack_public_path__ + "img/standalone-1.fa288a66.png";